import styled from 'styled-components';

export const MapEmptyState = styled.div`
  width: 0px;

  .triangle {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 12px 6px 0 6px;
    border-color: white transparent transparent transparent;
    position: absolute;
    z-index: 100;
    right: 45px;
    bottom: 15px;
  }

  .main-container {
    background: white;
    position: absolute;
    z-index: 100;
    bottom: 27px;
    right: 27px;
    border-radius: 4px;
    color: #595959;

    .header {
      display: flex;
      padding: 25px 23px 12px 23px;

      .cont {
        display: flex;
        flex-direction: column;
        justify-content: center;
        svg {
          cursor: pointer;
        }

      }

      .main {
        flex: 1;
      }

      h4 {
        font-size: var(--font-size-lg);
        font-weight: 600;
        margin-bottom: 0px;
      }
    }

    .body {
      padding: 0px 23px 25px 23px;
      font-size: 12px;
      font-weight: 500;

      ul {
        margin-bottom: 0px;
        padding-left: 25px;
      }
    }
  }
`;

export default styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  flex: 1;
  width: 100%;

  &.project-map {
    margin: 0px var(--size-lg) var(--size-lg) var(--size-lg);
    width: calc(100% - 48px);
  }

  .risk-selector {
    &.first {
      .ant-slider-track {
        background: linear-gradient(to right,
          #73D13D 0%, #FADB14 24.3%, #FA8C16 47.4%, #FA8C16 72.05%, #CF1322 100%);
      }
    }

    &.second {
      .ant-slider-track {
        background: linear-gradient(to right,
          #73D13D 0%, #FADB14 33%, #FA8C16 66%, #FA8C16 100%);
      }
    }

    &.third {
      .ant-slider-track {
        background: linear-gradient(to right,
          #73D13D 0%, #FADB14 50%, #FA8C16 100%);
      }
    }

    &.fourth {
      .ant-slider-track {
        background: linear-gradient(to right,
          #73D13D 0%, #FADB14 100%);
      }
    }

    &.fifth {
      .ant-slider-track {
        background: linear-gradient(to right,
          #FADB14 0%, #FA8C16 33%, #FA8C16 66%, #CF1322 100%);
      }
    }

    &.sixth {
      .ant-slider-track {
        background: linear-gradient(to right,
          #FADB14 0%, #FA8C16 33%, #FA8C16 66%, #CF1322 100%);
      }
    }

    &.seventh {
      .ant-slider-track {
        background: linear-gradient(to right,
          #FADB14 0%, #FA8C16 100%);
      }
    }

    &.eigth {
      .ant-slider-track {
        background: linear-gradient(to right,
           #FA8C16 0%, #FA8C16 50%, #CF1322 100%);
      }
    }

    &.ninth {
      .ant-slider-track {
        background: linear-gradient(to right,
          #FA8C16 0%, #FA8C16 50%, #CF1322 100%);
      }
    }

    &.tenth {
      .ant-slider-track {
        background: linear-gradient(to right,
          #FA8C16 0%, #CF1322 100%);
      }
    }
    .risk-range{
      display: flex;
      justify-content: space-between;
      width: 100%;
      .range-container{
        display: flex;
        flex-direction: column;
        label {
          margin-bottom: 0.1rem;
        }
        .input-number{
          width: 60px
        }
      }
    }
  }

  .leaflet-popup-content {
    width: auto !important;
    min-width: 80px;

    h5 {
      margin-bottom: 0;
    }
  }

  .custom-popover {
    width: 230px;

    .list {
      display: flex;
      flex-direction: column;
      color: #595959;
      font-weight: 600;
      margin-top: 5px;

      .item {
        padding-top: 8px;
        padding-bottom: 8px;
        border-top: 1px solid #E1E1E1;
        border-bottom: 1px solid #E1E1E1;
        margin-top: -1px;
        display: flex;

        .main {
          flex: 1;

          img {
            margin-right: 6px;
          }
        }
      }
    }
  }

  .map-marker {
    text-align: center;
    width 100%;
    height: 100%;
    border-radius: 100% 100% 100% 0;

    .main {
      width: 100% !important;
      height: 100% !important;
      border-radius: 100% 100% 100% 0;
    }

    &.incident, &.other-event {
      .main {
        border-radius: 100%;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: white;
      }
    }

    &.risk {
      border: 2px solid white;
      border-radius: 100%;

      .main {
        border-radius: 100%;
      }

      &.none {
        .main {
          span {
            color: black;
          }
          background: #f1f1f1;
        }
      }

      &.veryLow {
        .main {
          background: #73D13D;
        }
      }

      &.low {
        .main {
          background: #FADB14;
        }
      }

      &.medium {
        .main {
          background: #FA8C16;
        }
      }

      &.high {
        .main {
          background: #FF4D4F;
        }
      }

      &.veryHigh {
        .main {
          background: #CF1322;
        }
      }

      .main {
        display: flex;
        flex-direction: column;
        justify-content: center;

        span {
          color: white;
          font-weight: 600;
        }
      }
    }

    &.location {
      border: 2px solid white;

      &.minesites-location {
        border-radius: 100% 100% 100% 0;

        .main {
          background: #ADC6FF;
          border-radius: 100% 100% 100% 0;
        }
      }

      &.villages-location {
        border-radius: 100% 100% 100% 0;
        .main {
          background: #2F54EB;
          border-radius: 100% 100% 100% 0;
        }
      }

      &.other-location {
        border-radius: 100% 100% 100% 0;
        .main {
          background: #10239E;
          border-radius: 100% 100% 100% 0;
        }
      }
    }

    &.datachain-icon {
      background: #003a70;
      border-radius: 100%;
      border: 3px solid white;

      .main-c {
        width: 100%:
        background: red;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        color: white;
        font-weight: 600;
      }
    }
  }

  .legend {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 100px;
    border-right: 1px solid #CCCCCC;
    .group {
      display: flex;
      flex-direction: column;
      padding: var(--size) 12px;
      border-bottom: 1px solid #CCCCCC;

      h1 {
        color: #595959;
        font-size: 14px;
        line-height: 22px;
		    font-family: SF UI Display;
        margin-bottom: 12px;
      }
      span {
        font-size: 15px;
        line-height: 25px;
        color: #000000;
        padding-left: 20px;
        position: relative;
        cursor: pointer;
        transition: .4s opacity;
      }
      span[shape="square"] {
        &::after {
          content: '';
          width: 8px;
          height: 8px;
          position: absolute;
          background: var(--color);
          top: -2.5px;
          left: 0;
          bottom: 0;
          margin: auto;
        }
      }
      span[shape="circle"] {
        &::after {
          content: '';
          width: 8px;
          height: 8px;
          position: absolute;
          background: var(--color);
          top: -2.5px;
          left: 0;
          bottom: 0;
          margin: auto;
          border-radius: 50%;
        }
      }
      span[shape="rect"] {
        &::after {
          content: '';
          display: block;
          position: absolute;
          left: 0;
          top: -2.5px;
          bottom: 8px;
          width: 0;
          height: 0;
          margin: auto;
          border-bottom: 8px solid var(--color);
          border-top: 8px solid transparent;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
        }
      }
    }
  }
  #map {
    width: 100%;
    background: rgba(0, 0, 0, 0.1);
    z-index: 1;
    .leaflet-bottom.leaflet-right {
      display: none;
    }
    button {
      position: absolute;
      z-index: 999;
      top: var(--size-lg);
      left: var(--size-lg);
      box-shadow: 0px 4px 8px 0px #00000040;
      display: flex;
      align-items: center;
    }
  }

  .map-control-buttons {
    position: absolute;
    bottom: var(--size-lg);
    right: var(--size-lg);
    z-index: 1;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 4px 8px 0px #0000001A;

    button {
      width: 30px;
      height: 30px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      background: white;
      outline: none;
      // border: 1px solid #CECECE;
      border: none;
      border-radius: 3px;
      &:not(:last-of-type) {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom: 1px solid #CECECE;
      }
      &:not(:first-of-type) {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
    }
  }
`;

export const Subject = styled.div`
  overflow-y: auto;
  width: 360px;
  padding: 0px 15px;
  display: flex;
  flex-direction: column;
  z-index: 100;
  background: white;
  max-height: 580px;

  .go-to-btn {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
  }

  .header {
    padding: 15px 0px;
    display: flex;
    div {
      display: flex;
      flex-direction: column;
      justify-content: center;

      label {
        margin: 0px;
        font-size: 18px;
        font-weight: 600;
      }
    }

    .main {
      flex: 1;
    }
  }

  .bordered {
    margin-top: 10px;
    border: 1px solid #CCCCCC;
    border-radius: 4px;

    .ant-pagination {
      margin-right: 8px;
    }

    .header {
      padding: 12px;
      border-bottom: 1px solid #CCCCCC;

      h3 {
        font-size: 18px;
        margin-bottom: 0px;
      }
    }

    .body {
      padding: 8px;
    }
  }

  .location-name {
    display: flex;

    div {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .main {
      flex: 1;
      margin-left: 6px;

      span {
        font-size: 15px;
        color: #001529;
      }
    }

    svg {
      color: var(--mmt-primary-70);
    }
  }

  .cont {
    margin-top: 20px;

    label {
      color: #8C8C8C;
      font-weight: 500;
    }
  }

  .gallery {
    .ant-carousel .slick-dots-bottom {
      bottom: var(--size);
    }

    .information-by {
      margin-top: -5px;
    }

    .header {
      display: flex;
      label {
        padding-top: 3px;
        margin-bottom: 0px;
      }

      .controller {
        flex: 1;
        display: flex;
        flex-direction: row;
        padding: 3px;
        justify-content: flex-end;
        color: #797777;
        
        .go-left {
          margin-right: 6px;
          cursor: pointer;
          margin-top: 4px;
        }
    
        .go-right {
          margin-left: 6px;
          cursor: pointer;
          margin-top: 4px;
        }
      }
    }

    .image-cont {
      position: relative;

      .skin {
        opacity: 0;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        color: white;
        position: absolute;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        transition: .4s opacity;

        .preview {
          flex: 1;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          flex-direction: column;
          justify-content: center;

          div {
            display: flex;
            justify-content: center;
            gap: 4px;

            svg {
              margin-top: 3px;
            }

            label {
              color: white;
              cursor: pointer;
              margin-bottom: 0px;
            }
          }
        }
      }

      &:hover {
        .skin {
          opacity: 1;
        } 
      }

      .image {
        width: 100%;
        height: 170px;
        background-position: top;
        background-size: cover;
      }
    }
  }

  .longitude-latitude {
    display: flex;

    .coordinate {
      flex: 1;

      .value {
        display: flex;

        div {
          displat: flex;
          flex-direction: column;
          justify-content: center;

          svg {
            color: var(--mmt-primary-70);
            margin-top: -4px;
            margin-right: 6px;
          }
        }
      }
    }
  }

  .go-to-subject {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    button {
      width: 140px;
      margin-left: auto;
      margin-bottom: 15px;
    }
  }

  .sources-cont {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
   
    p { 
      margin-bottom: 0px;
    }

    .sources-header {
      color: #8C8C8C;
      font-weight: 500;
      margin: 0px;
    }

    .sources {
      display: flex;
      flex-direction: column;
      margin-bottom: 10;

      .source {
        display: flex;
        padding: 10px 0px;
        border-bottom: 1px solid #8C8C8C;

        .main-c {
          display: flex;
          flex-direction: column;
          justify-content: center;
          flex: 1;
        }

        .link-cont {
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 60px;
        }
      }
    }
  }

  &.info-project-sider {
    max-height: 600px;
    border: 1px solid rgb(204, 204, 204);
    border-top-right-radius: 4px;
    border-top-bottom-radius: 4px;
  }
`;

export const MapFilters = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: white;
  border-radius: 3px;
  position: absolute;
  z-index: 1020;
  top: var(--size-lg);
  left: var(--size-lg);
  box-shadow: 0px 4px 8px 0px #00000040;
  width: 250px;
  -webkit-user-select: none;  
  -moz-user-select: none;    
  -ms-user-select: none;      
  user-select: none;

  .checkbox-container {
    display: flex;
    width: 200px;

    span {
      flex: 1;

    }
  }

  .content {
    padding: 12px;
    font-weight: 400;
    width: 100%;
    display: flex;
    flex-direction: column;
    .ant-checkbox-wrapper, .ant-radio-wrapper {
      font-size: 14px;
      font-weight: 400;
    }
    .ant-select {
      margin-bottom: 12px;
    }
  }

  header {
    width: 100%;
    padding: 12px !important;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: var(--font-size-lg) !important;
    color: #001529;
    position: relative;
    span[role="img"] {
      margin-right: 8px;
    }
    font-weight: 600;
    border-bottom: 0px;
    a {
      font-size: 12px;
      color: #C3C3C3;
      position: absolute;
      top: 0;
      right: var(--size-lg);
      bottom: 0;
      margin: auto;
      height: fit-content;
      &::after {
        content: '';
        width: 0;
        height: 0;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid #C3C3C3;
        position: absolute;
        bottom: 0;
        top: 0;
        right: -12px;
        margin: auto;
      }
    }
  }
`;
